module.exports = __webpack_public_path__ + "935080aa11c0aee90972e0da5f4945ca.pdf";